<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useFetchGlobalDeviceConfigurations } from "~/modules/globalDeviceConfiguration/composables/useFetchGlobalDeviceConfigurations";
import { useOrganizationStore } from "~/modules/organization/stores/useOrganizationStore";

const { currentOrganization } = storeToRefs(useOrganizationStore());

const { fetchAll, isLoading, results, error } =
  useFetchGlobalDeviceConfigurations({
    organizationCode: currentOrganization.value?.code,
  });

onMounted(fetchAll);
</script>

<template>
  <page-component :is-loading="isLoading" :error="error">
    <global-device-configuration-list :global-device-configurations="results" />
  </page-component>
</template>
